import { Box, Button, Center, Show, SimpleGrid, Text } from "@chakra-ui/react";
import { getBlogs } from "@services/blogs";
import React from "react";
import { Section, Title } from "../utils";
import BlogCard from "./BlogCard";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import UTMLink from "@components/UTMLink";
import { trackEvent } from "utils";
import { LP_BLOGS_VIEW_MORE } from "@constants/analytics";
import { useQuery } from "@tanstack/react-query";

const CustomDot = ({ index, onClick, active }: any) => {
  return (
    <>
      <Box
        cursor="pointer"
        key={`indicator-${index}`}
        bg={active ? "textPrimary" : "#FFF"}
        w={active ? 6 : 2}
        h={2}
        borderRadius={4}
        mx="4px"
        onClick={() => onClick()}
      />
    </>
  );
};

const Blogs = () => {
  const { data: blogsData } = useQuery({
    queryKey: ["blogs"],
    queryFn: async () => {
      const r = await getBlogs();
      return r.data?.posts || [];
    },
    initialData: [],
  });

  const responsive = {
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  return (
    <Section>
      <Center>
        <Title>Stay updated with our blog</Title>
      </Center>
      <Show above="769px">
        <SimpleGrid spacing="24px" columns={{ sm: 1, md: 3 }}>
          {blogsData.map((data: any) => (
            <React.Fragment key={Math.random()}>
              <BlogCard data={data} />
            </React.Fragment>
          ))}
        </SimpleGrid>
      </Show>
      <Show below="md">
        <Carousel
          responsive={responsive}
          arrows={false}
          showDots
          customDot={<CustomDot blogs={blogsData} />}
          renderDotsOutside={true}
        >
          {blogsData.map((data: any) => (
            <React.Fragment key={Math.random()}>
              <BlogCard data={data} />
            </React.Fragment>
          ))}
        </Carousel>
      </Show>
      <UTMLink
        href="/insights/resources"
        _hover={{
          borderBottom: "none",
        }}
        onClick={() => {
          trackEvent(LP_BLOGS_VIEW_MORE);
        }}
      >
        <Center w="100%">
          <Button
            p="12px 45px"
            borderRadius="8px"
            border="1px solid"
            borderColor="#AEDFCA"
            bg="initial"
            w="fit-content"
            _hover={{
              bg: "inherit",
            }}
          >
            <Text color="#060710" fontSize="16px" lineHeight="24px">
              View more
            </Text>
          </Button>
        </Center>
      </UTMLink>
    </Section>
  );
};

export default Blogs;
